import { render, staticRenderFns } from "./DataImplementationTable.vue?vue&type=template&id=31cab3f9&"
import script from "./DataImplementationTable.vue?vue&type=script&lang=js&"
export * from "./DataImplementationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports